import api from './api';

export const listSubjects = async (params = {}) => {
  const { data } = await api.get('/subjects', { params });
  return data;
};

export const createSubject = async (payload) => {
  const { data } = await api.post('/subjects', payload);
  return data;
};

export const updateSubject = async (id, payload) => {
  const { data } = await api.put(`/subjects/${id}`, payload);
  return data;
};

export const deleteSubject = async (id) => {
  const { data } = await api.delete(`/subjects/${id}`);
  return data;
};

export const getCapsPresets = async () => {
  const { data } = await api.get('/subjects/presets');
  return data;
};

export const seedCapsPresets = async (payload = {}) => {
  const { data } = await api.post('/subjects/seed-caps', payload);
  return data;
};

export default {
  listSubjects,
  createSubject,
  updateSubject,
  deleteSubject,
  getCapsPresets,
  seedCapsPresets,
};
